import Button from "components/ui/Button";
import type { MouseEvent } from "react";
import { useTranslation } from "react-i18next";
import { PurchaseStudentType } from "services/pricingModel/model";

interface Props {
  type: PurchaseStudentType;
  hdSubmit: (evt: MouseEvent<HTMLButtonElement>) => void;
  processing: boolean;
}

export default function SubmitButton({ type, hdSubmit, processing }: Props) {
  const { t } = useTranslation();
  const label =
    type === "self-study"
      ? t("Common.purchasePlan.dialogTitle")
      : t("Common.purchasePlan.purchaseLessons");
  return (
    <Button size="extra-large" type="submit" onClick={hdSubmit} loading={processing}>
      {processing ? t("Common.submitButton.processingPayment") : label}
    </Button>
  );
}
